export function isApiErrorResponse(obj) {
  return typeof obj === "object" && obj !== null && typeof obj.error === "string" && typeof obj.message === "string" && typeof obj.code === "string" && (typeof obj._status === "number" || typeof obj._status === "string");
}